import { render } from "./ShareUrlComponent.vue?vue&type=template&id=2d01d8e5&scoped=true"
import script from "./ShareUrlComponent.vue?vue&type=script&lang=js"
export * from "./ShareUrlComponent.vue?vue&type=script&lang=js"

import "./ShareUrlComponent.vue?vue&type=style&index=0&id=2d01d8e5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d01d8e5"]])

export default __exports__